import { connect } from "react-redux";
import {
  IntegrationsListInitialStateDTO,
  SubmerchantInitialStateDTO,
} from "../service/types";

import { RootState, TypedDispatch } from "../../../../redux/store";

import Integrations from "../components/Integrations";
import { getAppsByInstitute } from "../service/IntegrationsSlice";
import AddSubmerchant from "../components/NurturePayDetail/AddSubmerchant";
import {
  deleteSubmerchant,
  getSubmerchantList,
  saveSubmerchant,
  updateSubmerchant,
} from "../service/addSubmerchantSlice";

interface DispatchProps {
  GetSubmerchantList(id: string): void;
  DeleteSubmerchant(body: any): void;
  SaveSubmerchant(body: any): void;
  UpdateSubmerchant(body: any): void;
}

const mapStateToProps = (state: RootState): SubmerchantInitialStateDTO => {
  return {
    getSubmerchantLoading: state.submerchant.getSubmerchantLoading,
    getSubmerchantSuccess: state.submerchant.getSubmerchantSuccess,
    getSubmerchantError: state.submerchant.getSubmerchantError,
    getSubmerchantData: state.submerchant.getSubmerchantData,
    deleteSubmerchantLoading: state.submerchant.deleteSubmerchantLoading,
    deleteSubmerchantSuccess: state.submerchant.deleteSubmerchantSuccess,
    deleteSubmerchantError: state.submerchant.deleteSubmerchantError,
    saveSubmerchantLoading: state.submerchant.saveSubmerchantLoading,
    saveSubmerchantSuccess: state.submerchant.saveSubmerchantSuccess,
    saveSubmerchantError: state.submerchant.saveSubmerchantError,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetSubmerchantList: (id: string) => {
      dispatch(getSubmerchantList(id));
    },
    DeleteSubmerchant: (body: any) => {
      dispatch(deleteSubmerchant(body));
    },
    SaveSubmerchant: (body: any) => {
      dispatch(saveSubmerchant(body));
    },
    UpdateSubmerchant: (body: any) => {
      dispatch(updateSubmerchant(body));
    },
  };
};

export const SubmerchantComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddSubmerchant);
